import React, { Fragment, useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";


import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { setDataAction  } from 'redux/actions/getFormActions';
import MaterialDropZone from '../components/MaterialDropZone';
import { SentimentSatisfiedAltSharp } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const fileTypes = {
  'text/pdf': ['.pdf', '.docx', '.xlsx', '.jpeg', '.png', '.jpg', '.heic'],
}
const Form5 = (props) => {
    const {actions, token, formData, handleNext, handleBack } = props;
    const classes = useStyles();
    const [leaseFile, setLeaseFile] = useState([]);
    const [ledgerFile, setLedgerFile] = useState([]);
    const [otherFiles, setOtherFiles] = useState([]);

    useEffect(() => {
      setLeaseFile(formData.data.leaseFile || []);
      setLedgerFile(formData.data.ledgerFile || []);
      setOtherFiles(formData.data.otherFiles || []);
    }, [])

    const handleNextButton = () => {
      handleNext();
      actions.setDataAction({
        ...formData.data,
        leaseFile: leaseFile,
        ledgerFile: ledgerFile,
        otherFiles: otherFiles
      })
    }
  return (
    <Fragment>
          <Typography variant="h5" gutterBottom color="primary" sx={{mt: 5}} align="center">
            <b>Documents</b>
          </Typography>
          <Grid container justifyContent='center' sx={{ my: 2 }}>
              <Grid item xs={10}>
                <MaterialDropZone
                  files={leaseFile}
                  maxSize={12000000}
                  filesLimit={1}
                  text={
                      <>
                          <Typography color="primary" variant='h6'>Upload your Tenancy Agreement (Required) </Typography>
                          <Typography variant='body1'>Please be sure to upload the countersigned tenancy agreement that matches the previously entered tenancy dates</Typography>
                      </>
                    }
                  accept={fileTypes}
                  handleUpload={(value) => setLeaseFile(value)}
                />
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ my: 2 }}>
              <Grid item xs={10}>
                <MaterialDropZone
                  files={ledgerFile}
                  maxSize={12000000}
                  filesLimit={1}
                  text={
                    <>
                        <Typography color="primary" variant='h6'>Upload your Detailed Resident Ledger (Required)</Typography>
                        <Typography variant='body1'>Please be sure to upload the resident’s ledger that is for the full-term tenancy term and includes all charges, credits, and payments</Typography>
                    </>
                  }
                  accept={fileTypes}
                  handleUpload={(value) => setLedgerFile(value)}
                />
              </Grid>
          </Grid>
          <Grid container justifyContent='center' sx={{ my: 2 }}>
              <Grid item xs={10}>
                <MaterialDropZone
                  files={otherFiles}
                  maxSize={12000000}
                  filesLimit={10}
                  text={
                    <>
                        <Typography color="primary" variant='h6'>Upload your Other Documents (optional)</Typography>
                        <Typography variant='body1'>Other Documents means legal or eviction filing invoices, photos of 
                                  initial and/or any other documents that 
                                  are relevant to this claim
                        </Typography>
                    </>
                  }
                  accept={fileTypes}
                  handleUpload={(value) => setOtherFiles(value)}
                />
              </Grid>
          </Grid>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2 }}>
                <Button
                onClick={handleBack}
                sx={{ mr: 1 }}
                variant="contained"
                >
                Back
                </Button>

            <Button onClick={handleNextButton} variant="contained" disabled={!(leaseFile.length > 0 && ledgerFile.length > 0)}>
                <Typography variant='body1' >
                    Next
                </Typography>
            </Button>
        </Box>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators({ 
            setDataAction, 
        }, dispatch),
    };
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(Form5);
